import React, { Component } from 'react';

import { Header, Navbar } from '@C';
import { QuotationList } from '@C/CreditCustomerProfile/Quotation';
import ErrorBoundary from '@C/Error';

class QuotationPage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  render() {
    return (
      <main>
        <div className="page-wrapper">
          <Header title="Create dealer" />
          <Navbar />
          <div className="page-content">
            <section className="page-components">
              <ErrorBoundary>
                <QuotationList />
              </ErrorBoundary>
            </section>
          </div>
        </div>
      </main>
    );
  }
}

export { QuotationPage };
